import React, { useEffect, useState } from 'react';
import { Modal, Select, Row, Col, Button, message } from 'antd';
import {
    getAllUserList,
    getWorkspacegRuleList,
    addMemberWithRole,
} from '../../../../Redux/Apis/user/ApiConfig';
import './AddMembers.css';
const { Option } = Select;

const AddMembers = ({ workspaceDetailsData, openModel, handleClose }) => {
    const [dropdownData, setDropdownData] = useState({
        userList: [],
        roleList: [],
    });
    const [selectDropdownItem, setSelectDropdownItem] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (openModel) fetchDropdownData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openModel]);

    const renderUserDropdown = (data) => {
        return data.map((item) => (
            <Option key={`user-select-${item.id}`} value={item.id}>
                {item.first_name} {item.last_name}
            </Option>
        ));
    };

    const renderRoleDropdown = (data) => {
        return data.map((item) => (
            <Option key={`role-select-${item.id}`} value={item.id}>
                {item.name}
            </Option>
        ));
    };

    const fetchDropdownData = async () => {
        setIsLoading(true);
        try {
            const { data } = await getAllUserList();
            const { data: roles } = await getWorkspacegRuleList();
            setDropdownData({
                userList: data,
                roleList: roles.roles,
            });
        } catch (err) {}
        setIsLoading(false);
    };

    const handleUserDropdownItem = (item) => {
        setSelectDropdownItem({
            ...selectDropdownItem,
            user_id: item,
        });
    };

    const handleRoleSelectDropdownItem = (item) => {
        setSelectDropdownItem({
            ...selectDropdownItem,
            workspace_role_id: item,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await addMemberWithRole(
                workspaceDetailsData?.id,
                selectDropdownItem
            );
            onClose();
        } catch (err) {}
    };
    const onClose = () => {
        handleClose();
        setSelectDropdownItem({});
        setDropdownData({
            userList: [],
            roleList: [],
        });
    };
    return (
        <Modal
            title={<b>Add Member's</b>}
            open={openModel}
            onCancel={onClose}
            footer={[
                <Button key='cancel' onClick={onClose}>
                    Cancel
                </Button>,
                <Button
                    key='submit'
                    type='primary'
                    onClick={handleSubmit}
                    disabled={Object.keys(selectDropdownItem).length !== 2}>
                    Add Member
                </Button>,
            ]}>
            {dropdownData?.userList?.length ? (
                <>
                    <hr className='add__member_header-line' />
                    <Row className='add__member_wrapper'>
                        <Col span={6}>
                            <label>
                                <b>Select Member: </b>
                            </label>
                        </Col>
                        <Col span={8}>
                            <Select
                                defaultValue='Select Member'
                                style={{ width: 250 }}
                                onChange={handleUserDropdownItem}>
                                {renderUserDropdown(dropdownData.userList)}
                            </Select>
                        </Col>
                    </Row>
                    <Row className='add__member_wrapper'>
                        <Col span={6}>
                            <label>
                                <b>Select Role: </b>
                            </label>
                        </Col>
                        <Col span={8}>
                            <Select
                                defaultValue='Select Role'
                                style={{ width: 250 }}
                                onChange={handleRoleSelectDropdownItem}>
                                {renderRoleDropdown(dropdownData.roleList)}
                            </Select>
                        </Col>
                    </Row>
                    <hr className='add__member_header-line' />
                </>
            ) : null}
            {isLoading ? (
                <div className='loader__member_add_wrapper'>
                    Loading Progress...{' '}
                </div>
            ) : null}
        </Modal>
    );
};

export default AddMembers;
